import React from 'react';
import TemplateAnalytics from '../../components/templates/TemplateAnalytics';
import { Helmet } from 'react-helmet';

// PROMPT-166: Template Analytics Dashboard Page for User

const UserTemplateAnalytics = () => {
  return (
    <>
      <Helmet>
        <title>Template Analytics - GoSMPP</title>
      </Helmet>
      
      <TemplateAnalytics isAdmin={false} />
    </>
  );
};

export default UserTemplateAnalytics;
